import type { CSSProperties, HTMLAttributes } from "react";

type ColorDotSize = "xs" | "sm" | "md" | "lg" | number;

const SIZE_MAP: Record<Exclude<ColorDotSize, number>, number> = {
  xs: 8,
  sm: 14,
  md: 20,
  lg: 26,
};

interface ColorDotProps extends HTMLAttributes<HTMLSpanElement> {
  color: string;
  size?: ColorDotSize;
  square?: boolean;
  selected?: boolean;
  bordered?: boolean;
}

export function ColorDot({ color, size, square = false, selected = false, bordered = false, className = "", style, ...props }: ColorDotProps) {
  const pixelSize = size === undefined ? undefined : typeof size === "number" ? size : SIZE_MAP[size];
  const cssVars = {
    "--mmm-color-dot-color": color,
    ...(pixelSize === undefined ? {} : { "--mmm-color-dot-size": `${pixelSize}px` }),
  } as CSSProperties;

  return (
    <span
      className={`mmm-color-dot ${square ? "mmm-color-dot--square" : ""} ${selected ? "is-selected" : ""} ${
        bordered ? "mmm-color-dot--bordered" : ""
      } ${className}`.trim()}
      style={{ ...cssVars, ...style }}
      {...props}
    />
  );
}
